import React, {Component} from 'react'
import Card from '../InstantBookingFinalInfo/Card'
import './InstantBookingWhy.scss'

class InstantBookingWhy extends Component {
    
    constructor(props) {
        super(props)
    }
    
    render() {
        return (
            <section className="InstantBookingWhy InstantBookingWhy-features">
                <div className="InstantBookingWhy-featuresWrapper container">
                    <div className="InstantBookingWhy-header">Почему удобно перевозить с Везёт Всем</div>
                    <div className="InstantBookingWhy-featureLine">
                        <Card
                            svgPath="shield.svg"
                            text="Гарантируем неизменность цены">
                            <p>Расчет цены происходит именно под вашу перевозку</p>
                            <p>Без ограничения по времени</p>
                            <p><strong>Окончательная цена, вместо почасовой оплаты</strong></p>
                        </Card>
                        <Card
                            text="Полный возврат денег"
                            svgPath="money.svg">
                            <p>
                                Возвращаем полную стоимость, если вы отменяете перевозку не менее чем за 5
                                часов до погрузки
                            </p>
                            <p>Наши платежные партнеры:</p>
                            <p><a target="_blank" href="https://kassa.yandex.ru">Яндекс Касса</a></p>
                            <p><a target="_blank" href="https://www.sberbank.ru/ru/s_m_business/bankingservice/acquiring_total#solutions-web">СБЕРБАНК</a></p>
                        </Card>
                    </div>
                    <div className="InstantBookingWhy-featureLine">
                        <Card
                            text="Бесплатные страхование грузов"
                            svgPath="contract.svg">
                            <p>Бесплатное страхование в том числе Б/У грузов со страховым покрытием до 100&nbsp;000&nbsp;₽.</p>
                            <p>Стаховой партнер САО «ВСК»</p>
                        </Card>
                        <Card
                            className="InstantBookingWhy-iconTrucks"
                            text="Проверенные исполнители"
                            svgPath="trucks.svg">
                            <p>Проверяем каждого перевозчика и верифицируем его транспорт</p>
                            <p><a target="_blank" href="/transportnye-kompanii">Более 160 000 исполнителей</a></p>
                        </Card>
                    </div>
                    <div className="InstantBookingWhy-featureLine">
                        <Card
                            text="Довольные заказчики"
                            svgPath="handshake.svg">
                            <p>Юридически сопровождаем вашу перевозку от начала и до конца</p>
                            <p>Поддержка 24 часа</p>
                            <p><a target="_blank" href="/otzyvy/pereezd/kvartirnyj_pereezd">Более 42 475 отзывов о
                                перевозках с Везёт Всем</a></p>
                        </Card>
                        <Card
                            svgPath="logo.svg">
                            <p>С 2010 года на рынке грузоперевозок</p>
                            <p>Резидент инновационного цента <a target="_blank"
                                                                href="https://sk.ru/net/1122256/">Сколково</a></p>
                            <p><a target="_blank" href="/about">Реквизиты и документы ООО Везёт Всем</a></p>
                        </Card>
                    </div>
                </div>
            </section>
        )
    }
}

export default InstantBookingWhy



// WEBPACK FOOTER //
// ./client/components/InstantBookingWhy/InstantBookingWhy.js